import actions from './actions';
import { fetchAndConstructPodcastObject } from '../../../modules/AnchorAPI/fetchCurrentUsersPodcast.ts';

const { setPodcast } = actions;

// TODO: Add fetch states: start, succeeded, failed
const fetchPodcastAndSet = () => dispatch =>
  fetchAndConstructPodcastObject().then(podcast => {
    dispatch(setPodcast(podcast));
  });

const getIsOptedOutOfDistributionFromPodcastStatus = podcastStatus => {
  const isOptedOutFromDatabase = podcastStatus === 'optedout';
  return isOptedOutFromDatabase;
};

export default {
  fetchPodcastAndSet,
  getIsOptedOutOfDistributionFromPodcastStatus,
};
